import * as React from 'react'
import type { CustomField } from 'types/business'
import type { DropdownOption } from 'types/ui'
import CustomDropdown from 'components/ui/dropdowns/custom-dropdown'
type Props = {
  customField: CustomField
  field: Record<string, any> | null | undefined
  disabled: boolean
  placeholder: string
  onChange: (options: string[] | null) => any
}
const emptyArray = []

const MetadataSelect = ({
  customField,
  field,
  disabled,
  placeholder,
  onChange,
}: Props): React.ReactNode => {
  const options: DropdownOption[] = customField.values
    ? customField.values.map(v => ({
        label: v,
        value: v,
      }))
    : emptyArray
  const multiField = customField.type === 'dropdown_multi'
  const value = field ? field.value : null
  let dropdownValue = null

  if (value && value.length > 0) {
    dropdownValue = multiField
      ? value.map(v => ({
          value: v,
          label: v,
        }))
      : {
          value: value[0],
          label: value[0],
        }
  } else if (field?.mixed) {
    dropdownValue = multiField
      ? [
          {
            value: 'Mixed',
            label: 'Mixed',
            clearableValue: false,
          },
        ]
      : {
          value: 'Mixed',
          label: 'Mixed',
        }
  }

  return (
    <CustomDropdown
      value={dropdownValue}
      disabled={disabled}
      multi={multiField}
      placeholder={placeholder}
      allowCreate={customField.allow_create}
      options={options}
      clearable
      onChange={options => {
        if (!options) return onChange([]) // server expects array to clear field

        onChange(
          multiField
            ? options // filter out "Mixed" only if field is mixed, otherwise it could be valid option
                .filter(o => !field?.mixed || o.value !== 'Mixed')
                .map(o => o.value)
            : [options.value],
        )
      }}
    />
  )
}

export default MetadataSelect
